<template>
  <div class="ba-w-100 ba-flex ba-gp-1 ba-f-column">
    <div class="header">
      <div class="header-title">
        <span class="ba-montserrat-600">{{ t.agency_accounts }}</span>
        <div class="underline"/>
      </div>

      <div class='ba-box-search-input'>
        <input type='search' class='ba-input' :placeholder='t.id_name_or_email' v-model="search" />
        <button class='ba-button'>
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-search' viewBox='0 0 16 16'>
            <path d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'/>
          </svg>
        </button>
      </div>

      <select class='ba-select ba-md' name='filter' v-model="filterSelected">
        <option v-for="(opt, i) in optionsFilter" :key="i" :value="opt.value">{{ opt.title }}</option>
      </select>

      <button
        class='ba-btn ba-md ba-blue add-button'
        @click="showCreateModal = true"
      >
        <i class="glyphicon glyphicon-plus ba-color-white1"></i>
        <span class="ba-montserrat-500 ba-color-white1">{{ t.agency_account }}</span>
      </button>
    </div>

    <span class="ba-montserrat-600 agency-counter text-end">{{ t.agency_accounts }}: {{ this.usersFilter.length }}</span>

    <table class='ba-table ba-lg ba-lines'>
      <thead>
      <tr>
        <th>{{ t.status }}</th>
        <th>{{ t.company_name_email }}</th>
        <th>{{ t.office2_autopilot_rede_send_mail_data_cadastro }}</th>
        <th>{{ t.valido_ate }}</th>
        <th>
          {{ t.wa_unpublish_content }}
          <div
            ba-tooltip-position='bottom'
            :ba-tooltip-title='t.wa_unpublish_content_tooltip'
            class="glyphicon glyphicon-info-sign"
            style="font-size: 12px"
          />
        </th>
        <th>
          {{ t.wa_delete_content }}
          <div
            ba-tooltip-position='bottom'
            :ba-tooltip-title='t.wa_delete_content_tooltip'
            class="glyphicon glyphicon-info-sign"
            style="font-size: 12px"
          />
        </th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="(user, i) in usersFilter"
        :key="i"
      >
        <td>
          <div class="ba-w-100 ba-flex ba-gp-1 ba-jc-center">
            <span class='ba-circle' :class="[user.is_blocked == '0' ? 'ba-green' : 'ba-red']"></span>
          </div>
        </td>
        <td class='ba-double'>
          <div class='ba-title'>{{ user.nome }}</div>
          <div class='ba-subtitle'>{{ user.email }}</div>
        </td>
        <td>
          <span>{{ user.cadastro }}</span>
        </td>
        <td>
          <span class="ba-montserrat-500" :class="[user.is_blocked == '0' ? '' : 'ba-color-red1']">{{ user.pag_validade }}</span>
        </td>
        <td>
          <span>{{ user.days_to_unpublish >= 0 ? daysToUnpublishContent(user.days_to_unpublish) : t.unpublished.toUpperCase() }}</span>
        </td>
        <td>
          <span>{{ user.days_to_delete >= 0 ? daysToRemoveContent(user.days_to_delete) : t.label_deleted.toUpperCase() }}</span>
        </td>
        <td>
          <div class="ba-flex ba-gp-04">
            <a class='ba-btn ba-md ba-rounded background-color--buttons p-default'
               ba-tooltip-position='top'
               :ba-tooltip-title='t.wa_access_office'
               :href="`${view.routes.rota_office_franchise_system_website_agencies_office_login}/${user.office_access_hash}`"
               target="_blank"
            >
              <builderall-icon code='c6a4' />
            </a>

            <button class='ba-btn ba-md ba-rounded background-color--buttons p-default'
                    ba-tooltip-position='top'
                    :ba-tooltip-title='t.label_wa_pay'
                    @click="payNow(user.office_id_plano, user.office_access_hash)"
            >
              <builderall-icon code='e35b' />
            </button>

            <button class="ba-btn ba-md ba-rounded"
              :class="user['is_blocked'] == '0' ? 'ba-btn-trash' : 'ba-btn-success'"
              ba-tooltip-position="top"
              :ba-tooltip-title="isButtonDisabled(user) ? t.wa_block_unblock_tooltip : (user['is_blocked'] == '0' ? t.title_wa_block : t.title_wa_unblock)"
              @click="updateStatus(user, user['is_blocked'] == '0' ? 'block' : 'unblock')"
              :disabled="isButtonDisabled(user)"
            >
              <builderall-icon :code="user['is_blocked'] == '0' ? '5eb3' : '2659'"/>
            </button>

            <button class='ba-btn ba-btn-trash ba-md ba-rounded'
                    ba-tooltip-position='top'
                    :ba-tooltip-title='t.translations_office_delete_account'
                    @click="deleteUser(user.id)"
            >
              <builderall-icon code='trash' />
            </button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="ba-modal"
         v-if="showCreateModal"
         @click="setToggleCreateModal ? emitToggleCreateModal() : ''"
    >
      <div
        class="ba-modal-content ba-flex ba-f-column ba-gp-3 ba-ai-end"
        @mouseleave="setToggleCreateModal = true" @mouseover="setToggleCreateModal = false"
      >
        <div class="ba-modal--header">
          <div class="header ba-flex ba-jc-sb">
            <h5 class="ba-montserrat-600 ba-color-blue1">{{ t.agency_account }}</h5>
            <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"
                 @click="emitToggleCreateModal" class="cursor-pointer">
              <g clip-path="url(#clip0_286_4540)">
                <path d="M11.0644 0.5C5.02466 0.5 0.128784 5.4247 0.128784 11.5C0.128784 17.5753 5.02466 22.5 11.0644 22.5C17.1041 22.5 22 17.5753 22 11.5C22 5.4247 17.1041 0.5 11.0644 0.5ZM15.1986 14.4915C15.519 14.8138 15.519 15.3357 15.1986 15.658C15.0384 15.8197 14.8284 15.9 14.6185 15.9C14.4085 15.9 14.1985 15.8197 14.0383 15.6586L11.0644 12.6666L8.09046 15.658C7.93025 15.8197 7.72028 15.9 7.51032 15.9C7.30036 15.9 7.09039 15.8197 6.93019 15.6586C6.60977 15.3363 6.60977 14.8143 6.93019 14.492L9.90467 11.5L6.93073 8.50855C6.61032 8.18625 6.61032 7.6643 6.93073 7.342C7.25115 7.0197 7.77004 7.0197 8.09046 7.342L11.0644 10.3335L14.0383 7.342C14.3587 7.0197 14.8776 7.0197 15.1981 7.342C15.5185 7.6643 15.5185 8.18625 15.1981 8.50855L12.2241 11.5L15.1986 14.4915Z" fill="#95ACCC"/>
              </g>
              <defs>
                <clipPath id="clip0_286_4540">
                  <rect width="21.8712" height="22" fill="white" transform="translate(0.128784 0.5)"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="underline"></div>
        </div>

        <div class="ba-modal--content">
          <span class="ba-montserrat-500">{{ t.text_create_new_sub_account }}</span>
        </div>

        <div class="ba-modal--footer">
          <button class='ba-btn ba-sm ba-blue'
                  @click="createAccount"
          >
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="Right icon" clip-path="url(#clip0_362_788)">
                <g id="Group">
                  <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M7.49998 2.16663C7.05795 2.16663 6.63403 2.34222 6.32147 2.65478C6.00891 2.96734 5.83331 3.39127 5.83331 3.83329V4.66663C5.83331 4.88764 5.92111 5.0996 6.07739 5.25588C6.23367 5.41216 6.44563 5.49996 6.66665 5.49996C6.88766 5.49996 7.09962 5.41216 7.2559 5.25588C7.41218 5.0996 7.49998 4.88764 7.49998 4.66663V3.83329H8.33331C8.55433 3.83329 8.76629 3.7455 8.92257 3.58921C9.07885 3.43293 9.16665 3.22097 9.16665 2.99996C9.16665 2.77895 9.07885 2.56698 8.92257 2.4107C8.76629 2.25442 8.55433 2.16663 8.33331 2.16663H7.49998ZM11.6666 2.16663C11.4456 2.16663 11.2337 2.25442 11.0774 2.4107C10.9211 2.56698 10.8333 2.77895 10.8333 2.99996C10.8333 3.22097 10.9211 3.43293 11.0774 3.58921C11.2337 3.7455 11.4456 3.83329 11.6666 3.83329H12.5C12.721 3.83329 12.933 3.7455 13.0892 3.58921C13.2455 3.43293 13.3333 3.22097 13.3333 2.99996C13.3333 2.77895 13.2455 2.56698 13.0892 2.4107C12.933 2.25442 12.721 2.16663 12.5 2.16663H11.6666ZM15.8333 2.16663C15.6123 2.16663 15.4003 2.25442 15.2441 2.4107C15.0878 2.56698 15 2.77895 15 2.99996C15 3.22097 15.0878 3.43293 15.2441 3.58921C15.4003 3.7455 15.6123 3.83329 15.8333 3.83329H16.6666V4.66663C16.6666 4.88764 16.7544 5.0996 16.9107 5.25588C17.067 5.41216 17.279 5.49996 17.5 5.49996C17.721 5.49996 17.933 5.41216 18.0892 5.25588C18.2455 5.0996 18.3333 4.88764 18.3333 4.66663V3.83329C18.3333 3.39127 18.1577 2.96734 17.8452 2.65478C17.5326 2.34222 17.1087 2.16663 16.6666 2.16663H15.8333ZM18.3333 7.99996C18.3333 7.77895 18.2455 7.56698 18.0892 7.4107C17.933 7.25442 17.721 7.16663 17.5 7.16663C17.279 7.16663 17.067 7.25442 16.9107 7.4107C16.7544 7.56698 16.6666 7.77895 16.6666 7.99996V8.83329C16.6666 9.05431 16.7544 9.26627 16.9107 9.42255C17.067 9.57883 17.279 9.66663 17.5 9.66663C17.721 9.66663 17.933 9.57883 18.0892 9.42255C18.2455 9.26627 18.3333 9.05431 18.3333 8.83329V7.99996ZM18.3333 12.1666C18.3333 11.9456 18.2455 11.7337 18.0892 11.5774C17.933 11.4211 17.721 11.3333 17.5 11.3333C17.279 11.3333 17.067 11.4211 16.9107 11.5774C16.7544 11.7337 16.6666 11.9456 16.6666 12.1666V13H15.8333C15.6123 13 15.4003 13.0878 15.2441 13.244C15.0878 13.4003 15 13.6123 15 13.8333C15 14.0543 15.0878 14.2663 15.2441 14.4225C15.4003 14.5788 15.6123 14.6666 15.8333 14.6666H16.6666C17.1087 14.6666 17.5326 14.491 17.8452 14.1785C18.1577 13.8659 18.3333 13.442 18.3333 13V12.1666Z" fill="white"/>
                  <path id="Vector_2" fill-rule="evenodd" clip-rule="evenodd" d="M3.33335 6.33325C2.89133 6.33325 2.4674 6.50885 2.15484 6.82141C1.84228 7.13397 1.66669 7.55789 1.66669 7.99992V17.1666C1.66669 17.6086 1.84228 18.0325 2.15484 18.3451C2.4674 18.6577 2.89133 18.8333 3.33335 18.8333H12.5C12.942 18.8333 13.366 18.6577 13.6785 18.3451C13.9911 18.0325 14.1667 17.6086 14.1667 17.1666V7.99992C14.1667 7.55789 13.9911 7.13397 13.6785 6.82141C13.366 6.50885 12.942 6.33325 12.5 6.33325H3.33335Z" fill="white"/>
                </g>
              </g>
              <defs>
                <clipPath id="clip0_362_788">
                  <rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
                </clipPath>
              </defs>
            </svg>
            {{ t.wa_copy_link }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "website-agency",
  props: ["view"],
  data() {
    return {
      t: [],
      users: null,
      search: '',
      usersFilter: null,
      setToggleCreateModal: true,
      showCreateModal: false,
      optionsFilter: null,
      filterSelected: 'all'
    }
  },
  mounted() {
    this.t = this.view.translations
    this.users = this.view.users
    this.usersFilter = this.view.users

    this.optionsFilter = [
      { title: this.t.translations_all, value: 'all' },
      { title: this.t.label_blocked, value: 'blocked' },
      { title: this.t.label_unblocked, value: 'unblocked' }
    ]
  },
  methods: {
    // [2025-03-28] - Updated payNow method and commented old logic by @carloseduardorocha
    // payNow(planID, userID, franchiseID) {
    //   var baI = 'pay-subaccount-invoice',
    //       vm = this;

    //   axios.post(this.view.routes.office_invoice_create_to_agency, {
    //     baI: baI,
    //     planId: planID,
    //     userId: userID,
    //     userIdFranchise: franchiseID
    //   })
    //     .then(response => {
    //       let _win = window.open(response.data.url, '_blank')
    //       _win.focus()
    //     })
    //     .catch(error => {
    //       console.error(error)
    //     })
    // },
    payNow(planID, userAccessHash) {
      let redir = '/us/office/pay-now/' + planID;
      let route = this.view.routes.rota_office_franchise_system_website_agencies_office_login + '/' + userAccessHash + '?redir=' + encodeURIComponent(redir);

      window.open(route, '_blank').focus();
    },
    deleteUser(userID) {
      let vm = this;

      axios.post(`delete-user/${userID}`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => {
          alertMsg('success', 'Account Deleted')
          vm.afterDeleteResponse(userID)
        })
        .catch(error => {
          alertMsg('error', 'Error on delete')
          console.error(error)
        })
    },
    updateStatus(user, operation) {
      var vm = this,
          bodyForm = new FormData();


      bodyForm.append('hash', user.hash)
      bodyForm.append('operation', operation)

      axios.post(this.view.routes.rota_office_franchise_system_website_agencies_change_status, bodyForm)
        .then(response => {
          alertMsg('success', this.t.label_success)
          vm.afterResponse(user.id, operation)
        })
        .catch(error => {
          alertMsg('error', this.t['ocorreu-erro'])
          console.error(error)
        })
    },
    afterResponse(userID, operation) {
      let nval = operation == 'block' ? '1' : '0'

      this.users.forEach(user => {
        user.is_blocked = user.id == userID ? nval : user.is_blocked
      })
    },
    daysToRemoveContent(days) {
      var data = moment().add(days, 'days')

      return `${data.format('YYYY-MM-DD')} (${days})`
    },
    daysToUnpublishContent(days) {
      var data = moment().add(days, 'days')

      return `${data.format('YYYY-MM-DD')} (${days})`
    },
    isButtonDisabled(user) {
      const today = moment().format('YYYY-MM-DD');

      return user['pag_validade'] < today && user['last_pag_validade'] < today;
    },
    afterDeleteResponse(userID) {
      var index = this.users.findIndex(x => x.id == userID)

      if (index != -1) {
        this.users.splice(index, 1)
      }
    },
    searchValue(val) {
      var regex = new RegExp(val.toLowerCase(), "i");

      this.usersFilter = this.users.filter(x => regex.test(x.nome))
    },
    createAccount() {
      let tempInput = document.createElement("input");
      tempInput.style = "position: absolute; left: -1000px; top: -1000px";
      tempInput.value = this.view.create_agency_url;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);

      alertMsg('info', this.t.copied)
    },
    emitToggleCreateModal() {
      this.showCreateModal = false
    },
    filterWithStatus(isBlocked) {
      this.usersFilter = this.users.filter(x => isBlocked ? x.is_blocked == '1' : x.is_blocked == '0')
    }
  },
  watch: {
    search(newVal, oldVal) {
      if (newVal != '') {
        this.searchValue(newVal)
      } else {
        this.usersFilter = this.users
      }
    },
    filterSelected(newVal) {
      if (newVal === 'all') {
        this.usersFilter = this.view.users
      } else {
        this.filterWithStatus(newVal == 'blocked')
      }
    }
  }
}
</script>

<style scoped lang="scss">

.header {
  height: 36.58px;
  display: grid;
  grid-template-columns: 1fr auto auto auto;
  gap: 16px;

  .header-title {
    width: auto;
    min-width: 30%;

    span {
      font-size: 14px;
      line-height: 16.5px;
      color: #4D5D71;
    }
  }

  .add-button {
    height: 100%;
    align-items: baseline !important;

    span, i {
      font-size: 12px !important;
    }
  }
}
.agency-counter {
  color: #4D5D71;
  font-size: 17px;
  line-height: 21.5px;
}

.underline {
  margin-top: 9px;
  width: 100%;
  background-color: #C4D1E0;
  height: 1px;
}

.text-end {
  text-align: end !important;
}

thead > tr {
  height: 64px !important;

  th {
    font-size: 12px !important;
  }
}

tbody > tr {
  height: 80px;

  span {
    font-size: 12px;
  }
}
.ba-double {
  .ba-title {
    font-size: 16px !important;
  }
  .ba-subtitle {
    font-size: 14px !important;
  }
}
.ba-input {
  font-size: 14px !important;
}
.ba-select {
  height: 36.58px !important;
  min-width: 112px !important;
}

.background-color--buttons {
  background-color: #EFF2F8;

  .svg-fill--color {
    fill: #8E9EB2;
  }

  builderall-icon {
    --builderall-icon-color: #94a4ba;
  }
}
.background-color--buttons:hover {
  background-color: #0080fc;

  &.delete {
    background-color: rgba(243, 85, 88, 0.20) !important;

    .svg-fill--color {
      fill: #F35558 !important;
    }
  }

  .svg-fill--color {
    fill: #FFFFFF;
  }

  builderall-icon {
    --builderall-icon-color: #fff;
  }
}
.p-default {
  padding: 1rem !important;
}

.ba-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1500;
  width: 100%;
  height: 93vh;
  background: rgba( 163, 163, 163, 0.25 );
  backdrop-filter: blur( 4px );
  -webkit-backdrop-filter: blur( 4px );

  display: flex;
  align-items: center;
  justify-content: center;

  .ba-modal-content {
    min-width: 600px;
    max-width: 950px;
    min-height: 260px;
    border-radius: 8px;
    background: #FFF;

    padding: 40px 20px;
    gap: 20px;

    .ba-modal--header {
      width: 100%;
      .header {
        width: 100%;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// resources/office/js/components/website-agency/WebsiteAgnecy.vue